<template>
  <div class="d2-plan-card-item" :class="{ 'current': plansListBData.plan_b_text == '使用中' || plansListBData.plan_b_text == 'Using' }">
    <div class="d2-plan-card-name">{{ plansListBData.plan_b_title }}</div>
    <div class="d2-plan-card-price-row"><span class="d2-plan-card-price">${{ plansListBData.plan_b_label_amount }}</span><span class="d2-plan-card-unit">/{{lang['components']['Plan']['PlanB']['time_unit']}}</span></div>
    <ul class="d2-plan-card-features">
      <li v-for="(item, index) in description">
          <i class="fas fa-check"></i> {{ item }}
      </li>
    </ul>
    <button v-if="plansListBData.plan_b_show" class="d2-plan-card-btn upgrade" @click="handleChickPlan(3, 'B', '', 'fb')">
      {{ plansListBData.plan_b_text }}
    </button>
    <button v-else-if="!plansListBData.planHaveBind" class="d2-plan-card-btn upgrade" @click="handleChickPlan(3, 'B', '', 'fb')">
      {{lang['components']['Plan']['PlanB']['is_expired']}}
    </button>
    <button
      v-else
      class="d2-plan-card-btn payagain"
      v-if="isExpiredData && (plansListBData.plan_b_text == '使用中' || plansListBData.plan_b_text == 'Using')"
      @click="handleChickPlan(3, 'B', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanB']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanB',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListB:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListBData: {
      get: function () {
        return this.plansListB
      },
      set: function (value) {
        this.$emit('update:plansListBData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListB.plan_b_description
    },
    isDisabled: function() {
       return this.plansListB.plan_b_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-B {
    &:hover {
      border: 2px #1D619F solid;
    }
  }
</style>